import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app.routing';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import packageJson from '../package.json';
import { ObservabilityModule } from '@michelin/observability';
import { EnvConfigurationService } from './app/shared/services/envconf.service';
import { AuthModule } from '@michelin/auth';
import { authInterceptor } from './app/shared/interceptors/auth.interceptor';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppRoutingModule),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    importProvidersFrom(
      ObservabilityModule.forRoot({
        app: {
          name: packageJson.name,
          version: packageJson.version,
          environment: EnvConfigurationService.getEnv()
        }
      })
    ),
    importProvidersFrom(AuthModule.forRoot(EnvConfigurationService.getAuthConfigEnv()))
  ]
}).catch((err) => console.error(err));
